import type { RouteRecordRaw } from 'vue-router';

import DefaultBarView from '@views/Navigation/DefaultBarView.vue';
import DefaultBreadcrumbView from '@views/Navigation/DefaultBreadcrumbView.vue';
import DefaultRailView from '@views/Navigation/DefaultRailView.vue';

import LeadDetail from '@views/Lead/LeadDetail.vue';
import ForwardLeadModal from '@views/Lead/Detail/Modals/ForwardLeadModal.vue';
import ReopenLeadModal from '@views/Lead/Detail/Modals/ReopenLeadModal.vue';
import DuplicateLeadModal from '@views/Lead/Detail/Modals/DuplicateLeadModal.vue';

import generateActionRoutes from '@router/action';
import ContactEdit from '@views/Contact/Detail/Modals/ContactEdit.vue';

const usedPrefixes: string[] = [];

export default (prefix: string): RouteRecordRaw[] => {
    if (usedPrefixes.includes(prefix)) {
        throw new Error(`Lead route prefix '${prefix}' is already in use`);
    }

    usedPrefixes.push(prefix);

    return [
        {
            path: 'lead/:leadId',
            name: `${prefix}LeadDetail`,
            props: {
                default: (route) => ({
                    leadId: route.params.leadId,
                }),
            },
            components: {
                default: LeadDetail,
                bar: DefaultBarView,
                rail: DefaultRailView,
                breadcrumbs: DefaultBreadcrumbView,
            },
            children: [
                {
                    path: 'forward',
                    name: `${prefix}ForwardLead`,
                    components: {
                        default: ForwardLeadModal,
                    },
                },
                {
                    path: 'reopen',
                    name: `${prefix}ReopenLead`,
                    components: {
                        default: ReopenLeadModal,
                    },
                    props: {
                        default: (route) => ({
                            leadId: route.params.leadId,
                            contactId: route.params.contactId,
                        }),
                    },
                },
                {
                    path: 'duplicate',
                    name: `${prefix}DuplicateLead`,
                    components: {
                        default: DuplicateLeadModal,
                    },
                    props: {
                        default: (route) => ({
                            leadId: route.params.leadId,
                            contactId: route.params.contactId,
                        }),
                    },
                },
                {
                    path: 'contact-edit',
                    name: 'leadContactEdit',
                    props: {
                        default: (route) => ({
                            contactId: route.params.contactId,
                        }),
                    },
                    components: {
                        default: ContactEdit,
                    },
                },
                ...generateActionRoutes('lead'),
            ],
        },
    ];
};
